(function(){
var SiloPopupEngine = (function () {
  var DAY = 86400000;
  var MOBILE_MAX = 749; /* Dawn's breakpoint: min-width 750px is desktop */

  function cleanPath(p) {
    var s = String(p || '/').split('?')[0].split('#')[0];
    if (s.length > 1 && s.charAt(s.length - 1) === '/') s = s.slice(0, -1);
    return (s || '/').toLowerCase();
  }

  function pageKind(path) {
    var p = cleanPath(path);
    if (p === '/') return 'home';
    if (p.indexOf('/products/') === 0) return 'product';
    if (p.indexOf('/collections/') === 0 && p.indexOf('/products/') > 0) return 'product';
    if (p === '/collections' || p.indexOf('/collections/') === 0) return 'collection';
    if (p === '/cart') return 'cart';
    if (p === '/search' || p.indexOf('/search/') === 0) return 'search';
    if (p.indexOf('/blogs/') === 0) return 'blog';
    if (p.indexOf('/pages/') === 0) return 'page';
    return 'other';
  }

  function ruleMatches(rule, path) {
    var kind = rule[0], val = String(rule[1] || '').toLowerCase();
    var p = cleanPath(path);
    if (kind === 'type') return val === 'all' || pageKind(p) === val;
    if (kind === 'path') return p === cleanPath(val);
    if (kind === 'prefix') return val !== '' && p.indexOf(cleanPath(val)) === 0;
    if (kind === 'contains') return val !== '' && p.indexOf(val) >= 0;
    return false;
  }

  function anyRule(rules, path) {
    for (var i = 0; i < (rules || []).length; i++) if (ruleMatches(rules[i], path)) return true;
    return false;
  }

  function pagesCheck(pg, path) {
    pg = pg || {};
    if (anyRule(pg.exc, path)) return 'page_excluded';
    if (pg.inc && pg.inc.length && !anyRule(pg.inc, path)) return 'page_not_included';
    return '';
  }

  /* Weekday (0 = Sunday) and hour in a time zone, via Intl (browser + node). */
  function zoned(now, tz) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: tz || 'UTC', weekday: 'short', hour: 'numeric', hourCycle: 'h23' }).formatToParts(new Date(now));
      var wd = -1, hr = -1, names = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type === 'weekday') wd = names.indexOf(parts[i].value);
        if (parts[i].type === 'hour') hr = Number(parts[i].value) % 24;
      }
      return { wd: wd, hr: hr };
    } catch (e) {
      var d = new Date(now);
      return { wd: d.getUTCDay(), hr: d.getUTCHours() };
    }
  }

  function scheduleCheck(sc, now) {
    sc = sc || {};
    if (sc.s && now < sc.s) return 'not_started';
    if (sc.e && now >= sc.e) return 'ended';
    if ((sc.wd && sc.wd.length) || (sc.h && sc.h.length === 2)) {
      var z = zoned(now, sc.tz);
      if (sc.wd && sc.wd.length && sc.wd.indexOf(z.wd) < 0) return 'off_day';
      if (sc.h && sc.h.length === 2) {
        var from = sc.h[0], to = sc.h[1];
        var inside = from <= to ? (z.hr >= from && z.hr < to) : (z.hr >= from || z.hr < to);
        if (!inside) return 'off_hours';
      }
    }
    return '';
  }

  function utmOk(rule, utm) {
    var have = String((utm || {})[rule[0]] || '').toLowerCase();
    var want = String(rule[2] || '').toLowerCase();
    if (rule[1] === 'equals') return have === want;
    if (rule[1] === 'contains') return want !== '' && have.indexOf(want) >= 0;
    if (rule[1] === 'not_equals') return have !== want;
    return false;
  }

  function audienceCheck(au, env) {
    au = au || {};
    var mobile = (env.width || 1024) <= MOBILE_MAX;
    if (au.d === 'mobile' && !mobile) return 'device';
    if (au.d === 'desktop' && mobile) return 'device';
    if (au.vi === 'new' && env.returning) return 'visitor';
    if (au.vi === 'returning' && !env.returning) return 'visitor';
    if (au.cu === 'logged_in' && env.customer !== 'logged_in') return 'customer';
    if (au.cu === 'guest' && env.customer === 'logged_in') return 'customer';
    for (var i = 0; i < (au.utm || []).length; i++) if (!utmOk(au.utm[i], env.utm)) return 'utm';
    if (au.ref && au.ref.length) {
      var ref = String(env.referrer || '').toLowerCase(), hit = false;
      for (var j = 0; j < au.ref.length; j++) if (au.ref[j] && ref.indexOf(String(au.ref[j]).toLowerCase()) >= 0) hit = true;
      if (!hit) return 'referrer';
    }
    if (au.mp > 0 && (env.pageviews || 0) < au.mp) return 'pageviews';
    return '';
  }

  /* History of THIS popup for THIS visitor: { views, last, sessionSeen,
     dismissed, clicked, submitted }. Manual opens (a visitor's own click)
     skip frequency entirely — clicking a button always answers. */
  function frequencyCheck(fq, h, env) {
    fq = fq || {};
    h = h || {};
    if (env.manual) return '';
    if (fq.rg !== false) {
      if (env.global && env.global.submitted) return 'global_submitted';
      if (env.global && env.global.refused) return 'global_refused';
    }
    var so = fq.so || [];
    if (so.indexOf('submit') >= 0 && h.submitted) return 'after_submit';
    if (so.indexOf('click') >= 0 && h.clicked) return 'after_click';
    if (so.indexOf('dismiss') >= 0 && h.dismissed) return 'after_dismiss';
    var vs = fq.vs || [];
    if (vs.indexOf('submit') >= 0 && h.visitSubmitted) return 'visit_after_submit';
    if (vs.indexOf('click') >= 0 && h.visitClicked) return 'visit_after_click';
    if (vs.indexOf('dismiss') >= 0 && h.visitDismissed) return 'visit_after_dismiss';
    if (fq.mx > 0 && (h.views || 0) >= fq.mx) return 'max_views';
    if (fq.m === 'session' && h.sessionSeen) return 'seen_session';
    if (fq.m === 'visitor' && (h.views || 0) > 0) return 'seen_ever';
    if (fq.m === 'days' && h.last && env.now - h.last < Math.max(1, fq.d || 1) * DAY) return 'seen_recently';
    return '';
  }

  /* Every rule for one popup, in the order a person would check them. */
  function check(p, env) {
    var hist = env.history ? env.history(p.k) : {};
    var steps = [
      ['status', p.off ? 'paused' : ''],
      ['schedule', scheduleCheck(p.sc, env.now)],
      ['page', pagesCheck(p.pg, env.path)],
      ['audience', audienceCheck(p.au, env)],
      ['frequency', frequencyCheck(p.fq, hist, env)]
    ];
    var out = [], ok = true;
    for (var i = 0; i < steps.length; i++) {
      var reason = steps[i][1];
      out.push({ rule: steps[i][0], ok: !reason, reason: reason });
      if (reason) ok = false;
    }
    return { k: p.k, ok: ok, checks: out };
  }

  function evaluate(cfg, env) {
    var res = [];
    var list = (cfg && cfg.popups) || [];
    for (var i = 0; i < list.length; i++) res.push(check(list[i], env));
    return res;
  }

  /* Of the keys (popups whose trigger just fired), which opens? Store-wide
     rules first (kill switch, per-session ceiling, cooldown), then each
     popup's own eligibility, then exclusion groups, then priority. Returns
     the winner and why every other one lost. */
  function choose(cfg, env, keys) {
    var losers = [], cands = [];
    var list = (cfg && cfg.popups) || [];
    var sess = env.session || {};
    var idx = {};
    for (var i = 0; i < list.length; i++) idx[list[i].k] = i;
    for (var j = 0; j < (keys || []).length; j++) {
      var p = list[idx[keys[j]]];
      if (!p) continue;
      if (cfg.kill) { losers.push({ k: p.k, reason: 'kill' }); continue; }
      if (!env.force || env.force !== p.k) {
        if (!env.manual && cfg.max > 0 && (sess.count || 0) >= cfg.max) { losers.push({ k: p.k, reason: 'max_session' }); continue; }
        if (!env.manual && cfg.cool > 0 && sess.last && env.now - sess.last < cfg.cool * 1000) { losers.push({ k: p.k, reason: 'cooldown' }); continue; }
        if (p.g && sess.groups && sess.groups.indexOf(p.g) >= 0 && (!sess.keys || sess.keys.indexOf(p.k) < 0)) { losers.push({ k: p.k, reason: 'group' }); continue; }
        var c = check(p, env);
        if (!c.ok) {
          for (var x = 0; x < c.checks.length; x++) if (!c.checks[x].ok) { losers.push({ k: p.k, reason: c.checks[x].reason }); break; }
          continue;
        }
      }
      cands.push(p);
    }
    cands.sort(function (a, b) {
      if (env.force) { if (a.k === env.force) return -1; if (b.k === env.force) return 1; }
      return (b.pr || 0) - (a.pr || 0) || idx[a.k] - idx[b.k];
    });
    for (var y = 1; y < cands.length; y++) losers.push({ k: cands[y].k, reason: 'priority' });
    return { winner: cands[0] ? cands[0].k : null, losers: losers };
  }


  /* ── The Pages board ("journey"): ordered popups per page lane ──────────
     cfg.j (journey.ts): lanes [[id, path, other]], a.first / a.return →
     lane id → steps { id, k, st, w, who, s, e }, gap (s), bo, ho (%).
     One popup at a time; a step's clock ("turn") starts at page load or when
     the previous popup on this page closed. Steps that don't qualify are
     skipped; the first that qualifies waits for its "when". */

  /* Exact path first, then the longest group (path*), then the catch-all. */
  function laneFor(j, path) {
    var p = cleanPath(path), best = null, bestLen = -1, other = null;
    for (var i = 0; i < (j.lanes || []).length; i++) {
      var l = j.lanes[i];
      if (l[2]) { if (!other) other = l[0]; continue; }
      var lp = String(l[1] || '');
      if (lp.charAt(lp.length - 1) === '*') {
        var pre = lp.slice(0, -1).toLowerCase();
        if ((p.indexOf(pre) === 0 || p + '/' === pre) && pre.length > bestLen) { best = l[0]; bestLen = pre.length; }
      } else if (cleanPath(lp) === p) return l[0];
    }
    return best || other;
  }

  /* And binds before Or: A or B and C = A, or (B and C). c[1] is the join. */
  function joined(list, fn) {
    if (!list || !list.length) return true;
    var groups = [[]];
    for (var i = 0; i < list.length; i++) {
      if (i > 0 && list[i][1] === 'or') groups.push([]);
      groups[groups.length - 1].push(fn(list[i], i));
    }
    for (var g = 0; g < groups.length; g++) {
      var all = true;
      for (var x = 0; x < groups[g].length; x++) if (!groups[g][x]) all = false;
      if (all) return true;
    }
    return false;
  }

  /* Where the visit came from, from its first-touch UTMs and click ids. */
  function sourceOf(env) {
    var u = env.utm || {}, s = String(u.utm_source || '').toLowerCase(), m = String(u.utm_medium || '').toLowerCase(), c = env.clid || '';
    if (c === 'fb' || /facebook|instagram|meta|^fb|^ig$/.test(s)) return 'meta';
    if (c === 'g' || /google|adwords|^gads/.test(s)) return 'google';
    if (c === 'tt' || /tiktok/.test(s)) return 'tiktok';
    if (m === 'email' || /email|klaviyo|newsletter/.test(s)) return 'email';
    return 'other';
  }

  /* One "who" condition: [type, join, is, value, variant]. */
  function whoOne(w, env) {
    var t = w[0], v = String(w[3] || ''), sig = env.signals || {}, hit;
    if (t === 'coupon' || t === 'subscribed' || t === 'bought' || t === 'cart') hit = !!sig[t];
    else if (t === 'source') hit = sourceOf(env) === v;
    else if (t === 'campaign') hit = v !== '' && String((env.utm || {}).utm_campaign || '').toLowerCase().indexOf(v.toLowerCase()) >= 0;
    else if (t === 'device') hit = ((env.width || 1024) <= MOBILE_MAX ? 'mobile' : 'desktop') === v;
    else if (t === 'ab') {
      var a = (env.ab || {})[v], want = String(w[4] || '').toLowerCase();
      hit = !!a && want !== '' && (String(a[0] || '').toLowerCase() === want || String(a[1] || '').toLowerCase() === want);
    } else return false;
    return w[2] === 0 ? !hit : hit;
  }

  /* Does a step on this page (this visit type) wait for theme trigger ev? */
  function boardWants(cfg, env, ev) {
    var j = cfg && cfg.j;
    if (!j) return false;
    var steps = ((j.a || {})[env.returning ? 'return' : 'first'] || {})[laneFor(j, env.path)] || [];
    for (var i = 0; i < steps.length; i++) {
      if (steps[i].st !== 'live' && !(steps[i].st === 'draft' && env.drafts)) continue;
      for (var w = 0; w < steps[i].w.length; w++) if (steps[i].w[w][0] === 'theme' && (',' + steps[i].w[w][2] + ',').indexOf(',' + ev + ',') >= 0) return true;
    }
    return false;
  }

  /* One "when" condition against the page clock ck:
     { sec: seconds since load, turn: when this step's turn began, tap: last
       input, reached: { "selector|pct": second it got there }, view: { selector: share in view } } */
  function whenOne(c, ck) {
    var t = c[0], turn = ck.turn || 0, v;
    if (t === 'time') { v = ck.sec - turn; return { met: v >= c[2], left: Math.max(0, c[2] - v) }; }
    if (t === 'idle') { v = ck.sec - Math.max(ck.tap || 0, turn); return { met: v >= c[2], left: Math.max(0, c[2] - v) }; }
    if (t === 'theme') {
      /* the first of these theme triggers to fire on this page view */
      var evs = String(c[2] || '').split(','), first = null;
      for (var x = 0; x < evs.length; x++) { var at = (ck.fired || {})[evs[x]]; if (at !== undefined && at !== null && (first === null || at < first)) first = at; }
      return first === null ? { met: false, left: -1 } : { met: true, left: 0 };
    }
    if (t === 'section') {
      var r = (ck.reached || {})[c[2] + '|' + c[3]];
      if (r === undefined || r === null) return { met: false, left: -1, view: (ck.view || {})[c[2]] || 0 };
      v = ck.sec - Math.max(r, turn);
      return { met: v >= (c[4] || 0), left: Math.max(0, (c[4] || 0) - v) };
    }
    return { met: false, left: -1 };
  }

  function whenState(list, ck) {
    var parts = [];
    for (var i = 0; i < (list || []).length; i++) parts.push(whenOne(list[i], ck));
    return { met: joined(list, function (c, i) { return parts[i].met; }), parts: parts };
  }

  /* Everything except the clock: may this step's popup show to this visitor? */
  function stepGate(step, env, byKey) {
    if (step.st === 'paused') return 'step_paused';
    if (step.st === 'draft' && !env.drafts) return 'step_draft';
    if (step.s && env.now < step.s) return 'step_not_started';
    if (step.e && env.now >= step.e) return 'step_ended';
    if (!joined(step.who, function (w) { return whoOne(w, env); })) return 'who';
    var p = byKey[step.k];
    if (!p) return 'popup_missing';
    if (p.off) return 'paused';
    return frequencyCheck(p.fq, env.history ? env.history(p.k) : {}, env);
  }

  /* Stable 0–99 bucket for a visitor id (FNV-1a). */
  function bucket(id) {
    var h = 2166136261, s = String(id || '');
    for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul ? Math.imul(h, 16777619) : (h * 16777619) | 0; }
    return (h >>> 0) % 100;
  }
  function inHoldout(cfg, visitorId) {
    var ho = (cfg && cfg.j && cfg.j.ho) || 0;
    return ho > 0 && bucket('silo-pp-hold:' + visitorId) < ho;
  }

  /* The board for this page view, step by step, with what happens next.
     page: { shown: [step ids shown (or held back) on this page view],
             open: step id on screen, busy: another popup is open, ck: clock }.
     env.session.lastClose: when any popup last closed (ms). env.holdout:
     this visitor is held back — the plan runs, its "ready" step is only
     recorded (the baseline's would-have-shown moment), never opened. */
  function journeyPlan(cfg, env, page) {
    var j = cfg && cfg.j;
    var out = { area: env.returning ? 'return' : 'first', lane: null, off: '', held: !!env.holdout, steps: [], ready: null };
    if (!j) { out.off = 'no_board'; return out; }
    page = page || {};
    out.lane = laneFor(j, env.path);
    var steps = ((j.a || {})[out.area] || {})[out.lane] || [];
    var byKey = {};
    for (var i = 0; i < ((cfg.popups) || []).length; i++) byKey[cfg.popups[i].k] = cfg.popups[i];
    var sess = env.session || {};
    if (cfg.kill) out.off = 'kill';
    else if (j.bo && (env.signals || {}).bought) out.off = 'buyer';
    else if (cfg.max > 0 && (sess.count || 0) >= cfg.max) out.off = 'max_session';
    var shown = page.shown || [], last = -1, cur = null;
    for (var a = 0; a < steps.length; a++) if (shown.indexOf(steps[a].id) >= 0) last = a;
    for (var n = 0; n < steps.length; n++) {
      var st = steps[n], row = { id: st.id, k: st.k, n: n + 1, state: '', reason: '' };
      out.steps.push(row);
      if (page.open && page.open === st.id) { row.state = 'showing'; cur = row; continue; }
      if (out.off) { row.state = 'off'; row.reason = out.off; continue; }
      if (shown.indexOf(st.id) >= 0) { row.state = 'done'; continue; }
      if (n < last) { row.state = 'passed'; continue; }
      if (cur) { row.state = 'next'; continue; }
      var g = stepGate(st, env, byKey);
      if (g) { row.state = g === 'step_paused' || g === 'step_draft' ? 'off' : 'skip'; row.reason = g; continue; }
      cur = row;
      if (page.open || page.busy) { row.state = 'waiting'; row.reason = 'busy'; continue; }
      var w = whenState(st.w, page.ck || { sec: 0 });
      row.when = w.parts;
      var gapLeft = sess.lastClose ? (j.gap || 0) * 1000 - (env.now - sess.lastClose) : 0;
      if (w.met && gapLeft > 0) { row.state = 'waiting'; row.reason = 'gap'; row.wait = Math.ceil(gapLeft / 1000); }
      else if (w.met) { row.state = 'ready'; out.ready = row; }
      else { row.state = 'waiting'; row.reason = 'when'; }
    }
    return out;
  }

  return {
    laneFor: laneFor, joined: joined, sourceOf: sourceOf, whoOne: whoOne, whenOne: whenOne, whenState: whenState,
    stepGate: stepGate, boardWants: boardWants, bucket: bucket, inHoldout: inHoldout, journeyPlan: journeyPlan,
    pageKind: pageKind, ruleMatches: ruleMatches, pagesCheck: pagesCheck,
    scheduleCheck: scheduleCheck, audienceCheck: audienceCheck,
    frequencyCheck: frequencyCheck, check: check, evaluate: evaluate, choose: choose,
    MOBILE_MAX: MOBILE_MAX
  };
})();


  if (window.__siloPopups) return;
  var CFG = null;
  try {
    if (window.__SILO_POPUPS_PREVIEW) CFG = window.__SILO_POPUPS_PREVIEW;
    else {
      var node = document.getElementById('silo-popups-config');
      if (node && node.textContent && node.textContent.trim()) CFG = JSON.parse(node.textContent);
    }
  } catch (e) { CFG = null; }
  if (!CFG || CFG.v !== 1 || !CFG.popups || !CFG.popups.length && !CFG.kill) return;
  var PREVIEW = !!CFG.preview;
  /* Dormant (the theme runs exactly as today) unless SILO has taken over, or
     the kill switch must hold the theme's own popups closed too. */
  if (!CFG.takeover && !CFG.kill && !PREVIEW) return;

  var E = SiloPopupEngine;
  var POPUPS = CFG.popups;
  var BY_KEY = {};
  for (var i0 = 0; i0 < POPUPS.length; i0++) BY_KEY[POPUPS[i0].k] = POPUPS[i0];
  var DEBUG = PREVIEW;
  try { DEBUG = DEBUG || /[?&]silo_popups_debug=1/.test(location.search); } catch (e) {}
  function log() { if (DEBUG && window.console) { try { console.log.apply(console, ['[SILO popups]'].concat([].slice.call(arguments))); } catch (e) {} } }

  /* ── storage: real on the store, in-memory in a preview ─────────────── */
  var MEM = {};
  function store(kind) {
    var real = null;
    if (!PREVIEW) { try { real = kind === 'local' ? window.localStorage : window.sessionStorage; } catch (e) { real = null; } }
    return {
      get: function (k) { try { return real ? real.getItem(k) : (MEM[kind + k] === undefined ? null : MEM[kind + k]); } catch (e) { return null; } },
      set: function (k, v) { try { if (real) real.setItem(k, v); else MEM[kind + k] = String(v); } catch (e) {} }
    };
  }
  var LS = store('local'), SS = store('session');
  function readJson(s, k, dflt) { try { var v = s.get(k); return v ? JSON.parse(v) : dflt; } catch (e) { return dflt; } }

  var hist = readJson(LS, 'silo_pp_h', {});
  var sess = readJson(SS, 'silo_pp_s', null);
  var returning = !!LS.get('silo_pp_v');
  if (!sess) {
    sess = { count: 0, last: 0, groups: [], keys: [], seen: {}, pv: 0, ret: returning };
    LS.set('silo_pp_v', String(Date.now()));
  }
  sess.pv = (sess.pv || 0) + 1;
  function saveSess() { SS.set('silo_pp_s', JSON.stringify(sess)); }
  function saveHist() { LS.set('silo_pp_h', JSON.stringify(hist)); }
  saveSess();

  /* First-touch campaign + referrer for this visit. */
  var utm = readJson(SS, 'silo_pp_utm', null);
  try {
    var q = new URLSearchParams(location.search), found = {}, any = false;
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (p) { var v = q.get(p); if (v) { found[p] = v; any = true; } });
    if (!utm && any) { utm = found; SS.set('silo_pp_utm', JSON.stringify(utm)); }
  } catch (e) {}
  var referrer = SS.get('silo_pp_ref');
  if (referrer === null) {
    referrer = '';
    try { if (document.referrer && new URL(document.referrer).hostname !== location.hostname) referrer = document.referrer; } catch (e) {}
    SS.set('silo_pp_ref', referrer);
  }
  /* Ad click id of the landing URL (Meta / Google / TikTok), for "came from". */
  var clid = SS.get('silo_pp_clid');
  if (clid === null) {
    clid = '';
    try { var q2 = new URLSearchParams(location.search); clid = q2.get('fbclid') ? 'fb' : q2.get('gclid') || q2.get('gbraid') || q2.get('wbraid') ? 'g' : q2.get('ttclid') ? 'tt' : ''; } catch (e) {}
    SS.set('silo_pp_clid', clid);
  }

  /* ── what the store knows about the visitor (the board's "who") ─────── */
  var SIG = window.__siloPopupSignals || {}; /* printed by the theme snippet when it can */
  var cartCount = typeof SIG.cart === 'number' ? SIG.cart : -1;
  function cookie(name) { try { var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; } }
  function signals() {
    return {
      coupon: !!(cookie('discount_code') || SIG.coupon),
      subscribed: !!(SIG.subscribed || LS.get('silo_pp_sub') === '1' || LS.get('popupFormSubmit') === 'true'),
      bought: !!((SIG.orders || 0) > 0 || LS.get('silo_bought') === '1'),
      cart: cartCount > 0
    };
  }
  function abAssignments() {
    var out = {}, list = PREVIEW ? [] : readJson(LS, 'ab_assignments', []);
    for (var i = 0; i < (list || []).length; i++) { var a = list[i]; if (a && a.testId) out[a.testId] = [String(a.variant || ''), String(a.name || '')]; }
    return out;
  }
  /* The holdout: a stable share of visitors who never see a board popup. */
  var vid = LS.get('silo_pp_vid');
  if (!vid) { vid = Date.now().toString(36) + Math.random().toString(36).slice(2, 10); LS.set('silo_pp_vid', vid); }
  var HOLD = !PREVIEW && E.inHoldout(CFG, vid);

  function customer() {
    try {
      var id = (window.__st && window.__st.cid) || (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.customerId);
      return id ? 'logged_in' : 'guest';
    } catch (e) { return 'guest'; }
  }

  function env(extra) {
    var e = {
      path: location.pathname, now: Date.now(), width: window.innerWidth || 1024,
      returning: !!sess.ret, customer: customer(), utm: utm || {}, referrer: referrer || '',
      pageviews: sess.pv || 1,
      global: PREVIEW ? { submitted: false, refused: false } : { submitted: LS.get('popupFormSubmit') === 'true', refused: LS.get('popupRefused') === 'true' },
      history: function (k) {
        var h = hist[k] || {}, v = (sess.acted || {})[k] || {};
        return { views: h.v || 0, last: h.l || 0, sessionSeen: !!(sess.seen && sess.seen[k]), dismissed: !!h.d, clicked: !!h.c, submitted: !!h.s,
          visitDismissed: !!v.d, visitClicked: !!v.c, visitSubmitted: !!v.s };
      },
      session: { count: sess.count || 0, last: sess.last || 0, groups: sess.groups || [], keys: sess.keys || [], lastClose: sess.lastClose || 0 },
      signals: signals(), ab: abAssignments(), clid: clid || '', holdout: HOLD, drafts: PREVIEW
    };
    if (extra) for (var x in extra) e[x] = extra[x];
    return e;
  }

  /* ── events (Phase 0 helper), never from a preview ─────────────────── */
  function emit(k, action, extra) {
    if (PREVIEW) return;
    try { if (window.siloPopupEvents) window.siloPopupEvents.popupEvent(k, action, extra || {}); } catch (e) {}
  }
  var REASON = {
    global_submitted: 'submitted', after_submit: 'submitted', global_refused: 'refused',
    after_click: 'frequency', after_dismiss: 'frequency', max_views: 'frequency', seen_session: 'frequency', seen_ever: 'frequency', seen_recently: 'frequency',
    group: 'priority', priority: 'priority', busy: 'priority', cooldown: 'cooldown', max_session: 'max_session', kill: 'kill'
  };

  /* ── content: apply an instance, undo the previous one ─────────────── */
  var ORIG = {}; /* "kind|selector|attr" → [elements, values] ; "cfg|key" → value */
  function ctx() { window.ShopifyContext = window.ShopifyContext || {}; window.ShopifyContext.popup = window.ShopifyContext.popup || {}; return window.ShopifyContext.popup; }
  function restoreAll() {
    for (var key in ORIG) {
      var o = ORIG[key];
      try {
        if (o.cfg) { ctx()[o.cfg] = o.value; continue; }
        for (var i = 0; i < o.els.length; i++) {
          var el = o.els[i], v = o.vals[i];
          if (o.k === 'text') el.textContent = v;
          else if (o.k === 'html') el.innerHTML = v;
          else if (o.k === 'attr') { if (v === null) el.removeAttribute(o.a); else el.setAttribute(o.a, v); }
          else if (o.k === 'cssvar') { if (v) el.style.setProperty(o.a, v); else el.style.removeProperty(o.a); }
        }
      } catch (e) {}
    }
  }
  function campaignOwns(p) {
    try { return p.t === 'quiz' && !!document.querySelector('#silo-popup-inner[data-silo-owner^="campaign:"]'); } catch (e) { return false; }
  }
  function applyOps(p) {
    restoreAll();
    if (!p.ops || !p.ops.length) return;
    if (campaignOwns(p)) { log('content of', p.k, 'skipped: a live campaign owns this popup'); return; }
    for (var i = 0; i < p.ops.length; i++) {
      var op = p.ops[i];
      try {
        if (op.k === 'config') {
          for (var c = 0; c < op.c.length; c++) {
            var ck = 'cfg|' + op.c[c];
            if (!ORIG[ck]) ORIG[ck] = { cfg: op.c[c], value: ctx()[op.c[c]] };
            ctx()[op.c[c]] = op.v;
          }
          continue;
        }
        var els = document.querySelectorAll(op.s);
        var key = op.k + '|' + op.s + '|' + (op.a || '');
        if (!ORIG[key]) {
          var vals = [];
          for (var j = 0; j < els.length; j++) {
            var el = els[j];
            vals.push(op.k === 'text' ? el.textContent : op.k === 'html' ? el.innerHTML : op.k === 'attr' ? el.getAttribute(op.a) : el.style.getPropertyValue(op.a));
          }
          ORIG[key] = { k: op.k, a: op.a, els: [].slice.call(els), vals: vals };
        }
        for (var m = 0; m < els.length; m++) {
          if (op.k === 'text') els[m].textContent = String(op.v);
          else if (op.k === 'html') els[m].innerHTML = String(op.v);
          else if (op.k === 'attr') els[m].setAttribute(op.a, String(op.v));
          else if (op.k === 'cssvar') els[m].style.setProperty(op.a, 'url(' + JSON.stringify(String(op.v)) + ')');
        }
      } catch (e) { log('content op failed', op, e); }
    }
  }

  /* ── opening, through the theme's own components ───────────────────── */
  var opening = false, current = {}; /* template → the instance last opened in it */
  var EVENT_ID = { quiz: 'roi', wizard: 'wizard', live: 'live', 'coupon-reminder': 'coupon-reminder', 'cart-reminder': 'cart-reminder', 'easypay-email': 'easypay-email' };
  function anyOpen() {
    try {
      var c = document.getElementById('silo-popup');
      if (c && c.classList.contains('popup-visible')) return true;
      /* The live-stream card is NOT counted: it steps aside by itself when a
         store popup opens (live-widget watchYield). Counting it here held back
         every popup — visitors' own button clicks included — while it was up. */
      return !!document.querySelector('savings-wizard.is-open, silo-live-popup.is-open, silo-notice-popup.is-open');
    } catch (e) { return false; }
  }
  function openPopup(p, trig) {
    var el = document.querySelector(p.el);
    if (!el) { log('cannot open', p.k, '- the', p.el, 'element is not on this page'); emit(p.k, 'error', { error: 'popup element missing', template: p.t }); return false; }
    applyOps(p);
    current[p.t] = p;
    opening = true;
    try {
      if (p.op === 'silo-popup-manager') { if (window.siloPopupManager) window.siloPopupManager.open(trig.ev || ('silo_' + trig.ty)); }
      else if (p.op === 'element-open-manual') el.open('custom_trigger');
      else el.open();
    } catch (e) { log('open failed', p.k, e); } finally { opening = false; }
    var now = Date.now();
    var h = hist[p.k] || {};
    h.v = (h.v || 0) + 1; h.l = now; hist[p.k] = h; saveHist();
    sess.count = (sess.count || 0) + 1; sess.last = now;
    sess.seen = sess.seen || {}; sess.seen[p.k] = 1;
    if (p.g && sess.groups.indexOf(p.g) < 0) sess.groups.push(p.g);
    if (sess.keys.indexOf(p.k) < 0) sess.keys.push(p.k);
    saveSess();
    log('opened', p.k, 'via', trig.ty, trig.ev || '');
    return true;
  }

  /* ── deciding ───────────────────────────────────────────────────────── */
  function decide(keys, trig, manual) {
    if (!keys.length) return null;
    var e = env({ manual: !!manual });
    if (PREVIEW && CFG.preview.force) {
      if (keys.indexOf(CFG.preview.force) < 0) { log('preview: ignoring', keys.join(','), '(previewing', CFG.preview.force + ')'); return null; }
      e.force = CFG.preview.force;
    }
    /* Never two at once — a click included (it cannot reach a button under an
       open modal anyway; a script can). */
    if (!e.force && anyOpen()) {
      for (var b = 0; b < keys.length; b++) emit(keys[b], 'suppressed', { reason: 'priority', trigger: trig.ev || trig.ty });
      log('held back', keys.join(','), '- another popup is open');
      return null;
    }
    if (HOLD && !manual && !e.force) {
      for (var hb = 0; hb < keys.length; hb++) emit(keys[hb], 'suppressed', { reason: 'holdout', trigger: trig.ev || trig.ty });
      log('holdout visitor: no automatic popup', keys.join(','));
      return null;
    }
    var r = E.choose(CFG, e, keys);
    for (var i = 0; i < r.losers.length; i++) {
      log('not shown:', r.losers[i].k, '-', r.losers[i].reason);
      /* Only an ELIGIBLE popup that lost is a suppression; one that was never
         allowed on this page/audience/schedule is not a missed opportunity. */
      if (REASON[r.losers[i].reason]) emit(r.losers[i].k, 'suppressed', { reason: REASON[r.losers[i].reason], trigger: trig.ev || trig.ty });
    }
    if (!r.winner) return null;
    var p = BY_KEY[r.winner];
    emit(p.k, 'triggered', { trigger: trig.ev || trig.ty, source: trig.src || undefined, template: p.t });
    return openPopup(p, trig) ? p : null;
  }

  /* Several triggers in the same moment compete; batch them for a tick. */
  var queue = [], queueTrig = null, qTimer = 0;
  function fire(p, trig) {
    if (queue.indexOf(p.k) < 0) queue.push(p.k);
    queueTrig = queueTrig || trig;
    clearTimeout(qTimer);
    qTimer = setTimeout(function () { var keys = queue, t = queueTrig; queue = []; queueTrig = null; decide(keys, t, false); }, 60);
  }

  /* The theme's LCP rule: nothing auto-opens before the first interaction. */
  var interacted = false, waiting = [];
  function afterInteraction(fn) { if (interacted) fn(); else waiting.push(fn); }
  ['scroll', 'pointerdown', 'keydown', 'touchstart', 'mousemove'].forEach(function (t) {
    window.addEventListener(t, function go() {
      if (interacted) return; interacted = true;
      var w = waiting; waiting = [];
      for (var i = 0; i < w.length; i++) { try { w[i](); } catch (e) {} }
    }, { passive: true, once: true });
  });

  /* ── SILO's own triggers ────────────────────────────────────────────── */
  function scrollPct() {
    var h = document.documentElement, b = document.body;
    var max = Math.max(h.scrollHeight, b ? b.scrollHeight : 0) - window.innerHeight;
    return max > 0 ? (window.scrollY / max) * 100 : 100;
  }
  function eligibleHere(p) {
    var c = E.check(p, env());
    return c.ok;
  }
  function wire(p, t) {
    var trig = { ty: t.ty, ev: '', src: '' };
    var done = false;
    function go() { if (done) return; done = true; afterInteraction(function () { fire(p, trig); }); }
    if (t.ty === 'page_load') go();
    else if (t.ty === 'delay') setTimeout(go, Math.max(0, t.v || 0) * 1000);
    else if (t.ty === 'scroll') {
      var onS = function () { if (scrollPct() >= (t.v || 50)) { window.removeEventListener('scroll', onS); go(); } };
      window.addEventListener('scroll', onS, { passive: true });
    } else if (t.ty === 'exit_intent') {
      if ((window.innerWidth || 0) > E.MOBILE_MAX) document.addEventListener('mouseout', function onX(ev) {
        if (!ev.relatedTarget && ev.clientY <= 0) { document.removeEventListener('mouseout', onX); go(); }
      });
    } else if (t.ty === 'inactivity') {
      var tm = 0;
      var reset = function () { clearTimeout(tm); tm = setTimeout(go, Math.max(1, t.v || 30) * 1000); };
      ['mousemove', 'keydown', 'scroll', 'touchstart'].forEach(function (n) { window.addEventListener(n, reset, { passive: true }); });
      reset();
    } else if (t.ty === 'element_view' && t.s && window.IntersectionObserver) {
      var tries = 0;
      (function find() {
        var els; try { els = document.querySelectorAll(t.s); } catch (e) { return; }
        if (!els.length) { if (++tries < 20) setTimeout(find, 250); return; }
        var io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) if (entries[i].isIntersecting) { io.disconnect(); go(); return; }
        }, { threshold: Math.min(1, Math.max(0.01, (t.v || 25) / 100)) });
        for (var j = 0; j < els.length; j++) io.observe(els[j]);
      })();
    } else if (t.ty === 'click' && t.s) {
      document.addEventListener('click', function (ev) {
        var hit = null; try { hit = ev.target && ev.target.closest && ev.target.closest(t.s); } catch (e) {}
        if (!hit) return;
        var href = hit.getAttribute && hit.getAttribute('href');
        if (!href || href === '#') ev.preventDefault();
        decide([p.k], { ty: 'click', ev: '', src: '' }, true);
      }, true);
    } else if (t.ty === 'url_param' && t.s) {
      try {
        var parts = t.s.split('='), qv = new URLSearchParams(location.search).get(parts[0]);
        if (qv !== null && (parts.length < 2 || qv === parts.slice(1).join('='))) go();
      } catch (e) {}
    } else if (t.ty === 'add_to_cart') {
      onCartAdd(function () { done = false; go(); });
    }
  }

  var cartHooks = [];
  function onCartAdd(fn) {
    cartHooks.push(fn);
    if (cartHooks.length > 1) return;
    var hit = function () { for (var i = 0; i < cartHooks.length; i++) { try { cartHooks[i](); } catch (e) {} } };
    var isAdd = function (u) { return /\/cart\/add(\.js)?(\?|$)/.test(String(u || '')); };
    try {
      var of = window.fetch;
      if (of) window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url);
        return of.apply(this, arguments).then(function (res) { if (isAdd(url) && res && res.ok) hit(); return res; });
      };
    } catch (e) {}
    try {
      var oo = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (m, u) {
        if (isAdd(u)) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) hit(); });
        return oo.apply(this, arguments);
      };
    } catch (e) {}
  }

  /* ── the theme's triggers, intercepted ──────────────────────────────── */
  /* A visitor's own click: always answered (no frequency / session limits). */
  var MANUAL = { button_triggered: 1, badge_triggered: 1, hero_badge: 1, promo_banner: 1, coupon_cta: 1, wizard_click: 1, custom_trigger: 1, dev_button: 1, element_api: 1, click: 1 };
  function themeRequest(eventName, source) {
    /* An open with no name is an automatic one the theme never labelled. */
    eventName = eventName || 'auto_triggered';
    if (!source && eventName === 'button_triggered') source = 'announcement';
    var keys = [];
    for (var i = 0; i < POPUPS.length; i++) {
      var p = POPUPS[i];
      for (var j = 0; j < p.tr.length; j++) {
        var t = p.tr[j];
        if (t.ty !== 'theme_event') continue;
        if (t.ev && t.ev.length && t.ev.indexOf(eventName) < 0) continue;
        if (t.src && t.src.length && (!source || t.src.indexOf(source) < 0)) continue;
        keys.push(p.k); break;
      }
    }
    var manual = !!(MANUAL[eventName] || source);
    /* An automatic theme trigger a Pages-board step on this page waits for:
       the board decides (in order, one at a time) on its next tick. */
    if (!manual && J && !(PREVIEW && CFG.preview.force) && E.boardWants(CFG, env(), eventName)) {
      if (PAGE.ck.fired[eventName] === undefined) PAGE.ck.fired[eventName] = secs();
      log('theme trigger', eventName, '→ the Pages board');
      return null;
    }
    log('theme trigger', eventName, source || '', '→ candidates', keys.join(',') || 'none');
    var trig = { ty: 'theme_event', ev: eventName, src: source || '' };
    var opened = null;
    var run = function () { opened = decide(keys, trig, manual); };
    if (manual) run(); else afterInteraction(run);
    return opened ? (opened.t === 'quiz' ? 'popup' : opened.t) : null;
  }

  function install() {
    if (window.siloOpenPopup && !window.siloOpenPopup.__silo) {
      var wrapped = function (eventName, source) { return themeRequest(eventName, source); };
      wrapped.__silo = true;
      window.siloOpenPopup = wrapped;
    }
    var m = window.siloPopupManager;
    if (m && m.open && !m.open.__silo) {
      var mo = m.open;
      var w1 = function (eventName) { if (opening) return mo.apply(this, arguments); themeRequest(eventName, ''); };
      w1.__silo = true;
      m.open = w1;
    }
    [['savings-wizard', 'wizard_click'], ['silo-live-popup', 'custom_trigger']].forEach(function (pair) {
      var C = window.customElements && window.customElements.get(pair[0]);
      if (!C || !C.prototype.open || C.prototype.open.__silo) return;
      var o = C.prototype.open;
      var w2 = function (reason) { if (opening) return o.apply(this, arguments); themeRequest(typeof reason === 'string' ? reason : pair[1], ''); };
      w2.__silo = true;
      C.prototype.open = w2;
    });
  }

  /* ── lifecycle feedback (from the Phase 0 event helper) ─────────────── */
  function instanceFor(eventId) {
    if (BY_KEY[eventId]) return BY_KEY[eventId];
    for (var t in EVENT_ID) if (EVENT_ID[t] === eventId && current[t]) return current[t];
    return null;
  }
  function observe(eventId, action) {
    var inst = instanceFor(eventId);
    if (!inst) return;
    var h = hist[inst.k] || {};
    sess.acted = sess.acted || {};
    var v = sess.acted[inst.k] || {};
    if (action === 'dismiss') { h.d = 1; v.d = 1; }
    if (action === 'click') { h.c = 1; v.c = 1; }
    if (action === 'submit') { h.s = 1; v.s = 1; LS.set('silo_pp_sub', '1'); }
    hist[inst.k] = h; saveHist();
    sess.acted[inst.k] = v; saveSess();
  }
  function keyFor(eventId) {
    if (BY_KEY[eventId]) return null; /* already an instance key */
    var inst = instanceFor(eventId);
    return inst ? { k: inst.k, ver: inst.ver, t: inst.t, place: PLACE[inst.k] || undefined } : null;
  }

  /* ── the Pages board: one popup at a time, in order, per page ───────── */
  var J = CFG.j || null;
  var PAGE = { shown: [], open: '', busy: false, ck: { sec: 0, turn: 0, tap: 0, reached: {}, view: {}, fired: {} } };
  var PLACE = {}; /* popup key → "area:lane:step" of the board step that opened it */
  var T0 = Date.now(), wasOpen = false, jTimer = 0;
  function secs() { return (Date.now() - T0) / 1000; }
  function watchSection(sel, pct) {
    var key = sel + '|' + pct, tries = 0;
    if (!window.IntersectionObserver) return;
    (function find() {
      /* EVERY match: a section can render twice (a desktop block and a
         mobile slide, one of them display:none) — whichever is seen counts. */
      var els = null; try { els = document.querySelectorAll(sel); } catch (e) { return; }
      if (!els.length) { if (++tries < 40) setTimeout(find, 250); return; }
      var steps = []; for (var t = 0; t <= 20; t++) steps.push(t / 20);
      var ratios = [];
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var en = entries[i], h = en.boundingClientRect.height || 1;
          var ix = [].indexOf.call(els, en.target); ratios[ix] = en.intersectionRatio;
          /* A section taller than the screen can never be 100% in view:
             "all of it" then means "as much of it as fits". */
          var need = Math.min(pct / 100, (window.innerHeight || h) / h) - 0.001;
          PAGE.ck.view[sel] = Math.round(Math.max.apply(null, ratios.concat([0])) * 100) / 100;
          if (en.intersectionRatio >= need && PAGE.ck.reached[key] === undefined) PAGE.ck.reached[key] = secs();
        }
      }, { threshold: steps });
      for (var oi = 0; oi < els.length; oi++) io.observe(els[oi]);
    })();
  }
  function journeyClosed() {
    sess.lastClose = Date.now(); saveSess();
    if (PAGE.open) { log('board step', PAGE.open, 'closed: the next turn starts now'); PAGE.open = ''; PAGE.ck.turn = secs(); }
  }
  function journeyTick() {
    PAGE.ck.sec = secs();
    var open = anyOpen();
    if (wasOpen && !open) journeyClosed();
    wasOpen = open;
    PAGE.busy = open && !PAGE.open;
    /* The clock runs from load; nothing opens before the first interaction. */
    if (!interacted || opening || CFG.kill) return;
    var plan = E.journeyPlan(CFG, env(), PAGE);
    var r = plan.ready;
    if (!r) return;
    var p = BY_KEY[r.k], place = plan.area + ':' + plan.lane + ':' + r.id;
    PAGE.shown.push(r.id);
    if (plan.held) {
      /* The holdout's baseline moment: it WOULD have shown now. */
      emit(p.k, 'held', { template: p.t, trigger: 'board', place: place });
      PAGE.ck.turn = PAGE.ck.sec;
      log('holdout: step', r.id, '(' + p.k + ') would have shown now');
      return;
    }
    PLACE[p.k] = place;
    emit(p.k, 'triggered', { trigger: 'board', template: p.t, place: place });
    if (openPopup(p, { ty: 'board', ev: '', src: '' })) { PAGE.open = r.id; wasOpen = true; }
    else PAGE.ck.turn = PAGE.ck.sec; /* could not render here: the next step's turn */
  }
  function journeyStart() {
    if (!J || (PREVIEW && CFG.preview.force)) return;
    var plan = E.journeyPlan(CFG, env(), PAGE);
    var steps = ((J.a || {})[plan.area] || {})[plan.lane] || [];
    log('board:', plan.area, 'visit ·', plan.lane, '·', steps.length, 'step(s)', HOLD ? '· HOLDOUT visitor' : '');
    if (!steps.length) return;
    var seen = {};
    for (var i = 0; i < steps.length; i++) for (var w = 0; w < steps[i].w.length; w++) {
      var c = steps[i].w[w];
      if (c[0] === 'section' && !seen[c[2] + '|' + c[3]]) { seen[c[2] + '|' + c[3]] = 1; watchSection(c[2], c[3]); }
    }
    ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach(function (n) { window.addEventListener(n, function () { PAGE.ck.tap = secs(); }, { passive: true }); });
    if (!PREVIEW && cartCount < 0) {
      try { fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { cartCount = (c && c.item_count) || 0; }).catch(function () {}); } catch (e) {}
    }
    onCartAdd(function () { cartCount = Math.max(1, cartCount + 1); });
    jTimer = setInterval(journeyTick, 250);
  }

  function explain(path) {
    var e = env(path ? { path: path } : null);
    var v = E.evaluate(CFG, e);
    if (window.console && console.table) console.table(v.map(function (x) {
      var bad = null; for (var i = 0; i < x.checks.length; i++) if (!x.checks[i].ok) { bad = x.checks[i]; break; }
      return { popup: x.k, eligible: x.ok, blocked_by: bad ? bad.rule + ': ' + bad.reason : '' };
    }));
    return v;
  }

  window.__siloPopups = {
    active: true, preview: PREVIEW, rev: CFG.rev, config: CFG,
    request: themeRequest, observe: observe, keyFor: keyFor, explain: explain,
    board: function () { return E.journeyPlan(CFG, env(), PAGE); }, holdout: HOLD,
    open: function (k) { var p = BY_KEY[k]; return p ? decide([k], { ty: 'manual', ev: '', src: 'qa' }, true) : null; }
  };

  function start() {
    /* Preview only: template-content drafts the theme's JS reads (coupon,
       offer titles…), patched before anything opens. */
    if (PREVIEW && window.__SILO_POPUPS_CONTENT_PREVIEW && window.__SILO_POPUPS_CONTENT_PREVIEW.js) {
      var jsPatch = window.__SILO_POPUPS_CONTENT_PREVIEW.js;
      for (var jk in jsPatch) ctx()[jk] = jsPatch[jk];
    }
    install();
    if (CFG.kill) { log('kill switch on: no popups'); return; }
    var here = E.evaluate(CFG, env());
    for (var i = 0; i < here.length; i++) if (here[i].ok) emit(here[i].k, 'eligible', { template: BY_KEY[here[i].k].t });
    for (var j = 0; j < POPUPS.length; j++) {
      var p = POPUPS[j];
      if (p.off || !eligibleHere(p) && !(PREVIEW && CFG.preview.force === p.k)) continue;
      for (var t = 0; t < p.tr.length; t++) if (p.tr[t].ty !== 'theme_event') wire(p, p.tr[t]);
    }
    if (DEBUG) explain();
    journeyStart();
    if (PREVIEW && CFG.preview.force) {
      /* A preview opens at once: release the store's first-interaction rule
         (the theme's and ours) the way a visitor's first touch would. */
      try { window.dispatchEvent(new Event('pointerdown')); } catch (e) {}
      var fk = CFG.preview.force;
      var tries = 0;
      (function forceOpen() {
        var p = BY_KEY[fk];
        if (!p) return;
        if (!document.querySelector(p.el) && ++tries < 30) { setTimeout(forceOpen, 200); return; }
        decide([fk], { ty: 'preview', ev: '', src: '' }, true);
      })();
    }
  }

  /* The admin canvas re-opens or swaps the config without a reload. */
  if (PREVIEW) window.addEventListener('message', function (ev) {
    var d = ev.data || {};
    if (d.type === 'silo-popups:open' && d.key && BY_KEY[d.key]) { restoreAll(); decide([d.key], { ty: 'preview', ev: '', src: '' }, true); }
    /* Popup content editor: unsaved text, shown as it is typed. Each text
       node inside the template's element is rebuilt from its ORIGINAL text
       with every [from, to] pair applied, so edits never compound. */
    if (d.type === 'silo-popups:swap' && d.scope && d.pairs) {
      try {
        var roots = document.querySelectorAll(d.scope);
        for (var ri = 0; ri < roots.length; ri++) {
          var walker = document.createTreeWalker(roots[ri], NodeFilter.SHOW_TEXT, null), tn;
          while ((tn = walker.nextNode())) {
            if (tn.__siloOrig === undefined) tn.__siloOrig = tn.nodeValue;
            var txt = tn.__siloOrig;
            for (var pi = 0; pi < d.pairs.length; pi++) { var fr = d.pairs[pi][0]; if (fr && txt.indexOf(fr) >= 0) txt = txt.split(fr).join(d.pairs[pi][1]); }
            if (tn.nodeValue !== txt) tn.nodeValue = txt;
          }
        }
      } catch (e) {}
    }
    if (d.type === 'silo-popups:explain') { try { ev.source && ev.source.postMessage({ type: 'silo-popups:explained', result: explain() }, '*'); } catch (e) {} }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else setTimeout(start, 0);

})();